// ToolInstallation.js
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./ToolInstallation.css";
import { getIcon } from "../../../utils/icons";
import {
  setCommandType,
  resetOperation,
  setCommandMessage,
} from "../../../redux/operationSlice";
import { COMMANDS } from "../../../utils/commonProperties";
import DropdownButton from "./DropdownButton";
import { togglePanel, selectPanelVisibilityForTab, panelsForTab } from "../../../redux/panelVisibilitySlice";
import { openEnergyRoom, selectEnergyRoomLaunchPayload } from "../../../redux/energyRoomSlice";

// Tesisat menüsünden show/hide edilen paneller
const PANEL_TOGGLES = [
  { key: "kolonSema", icon: "kolonSema", title: "Kolon Şeması paneli" },
  { key: "panoDetay", icon: "panoDetay", title: "Pano Detay paneli" },
  { key: "baslik", icon: "titleBlock", title: "Başlık paneli" },
  { key: "kabloBacasi", icon: "kabloRiser", title: "Kablo Bacası paneli" },
];

const boxOptions = [
  { key: "supply_box", icon: "box", label: "BOX", command: COMMANDS.DRAW_SUPPLY_POINT, message: "BOX konumunu seçin", toolTipText: "BOX" },
  { key: "supply_pole", icon: "pole", label: "DİREK", command: COMMANDS.DRAW_POLE, message: "Direk konumunu seçin", toolTipText: "DİREK" },
  { key: "supply_network", icon: "supply", label: "ŞEBEKE", command: COMMANDS.DRAW_NETWORK, message: "Şebeke konumunu seçin", toolTipText: "DAĞITIM FİRMASI" },
];
const socketOptions = [
  { key: "supply_box", icon: "box", label: "BOX", command: COMMANDS.DRAW_SUPPLY_POINT, message: "BOX konumunu seçin", toolTipText: "BOX" },
  { key: "supply_pole", icon: "pole", label: "DİREK", command: COMMANDS.DRAW_POLE, message: "Direk konumunu seçin", toolTipText: "DİREK" },
  { key: "supply_network", icon: "supply", label: "ŞEBEKE", command: COMMANDS.DRAW_NETWORK, message: "Şebeke konumunu seçin", toolTipText: "DAĞITIM FİRMASI" },
];

const ToolInstallation = () => {
  const [activeButton, setActiveButton] = useState(null);
  const [isOpen, setIsOpen] = useState(true);
  const buttonSize = 30;
  const iconSize = 22;
  const dispatch = useDispatch();
  const commandType = useSelector((state) => state.operation.commandType);
  // Panel görünürlüğü + toggle'lar AKTİF paftaya göre.
  const activeTabId = useSelector((state) => state.projectTabs.activeTabId);
  const panelVis = useSelector((state) => selectPanelVisibilityForTab(state, activeTabId));
  const energyRoomPayload = useSelector(selectEnergyRoomLaunchPayload);
  // Bu paftada kullanılabilir paneller (ör. Şantiye → yalnız başlık)
  const allowedPanels = panelsForTab(activeTabId);
  const visiblePanelToggles = PANEL_TOGGLES.filter((p) => allowedPanels.includes(p.key));

  useEffect(() => {
    switch (commandType) {
      case COMMANDS.DRAW_LINE:
        setActiveButton("line"); break;
      case COMMANDS.DRAW_ELECTRICAL_WIRE:
        setActiveButton("polyline"); break;
      case COMMANDS.DRAW_SPLINE:
        setActiveButton("spline"); break;
      case COMMANDS.DRAW_CIRCLE:
        setActiveButton("circle"); break;
      case COMMANDS.DRAW_LIGHT:
        setActiveButton("Light"); break;
      case COMMANDS.DRAW_FIXTURE:
        setActiveButton("LightFixture"); break;
      case COMMANDS.DRAW_RECT:
        setActiveButton("rect"); break;
      case COMMANDS.DRAW_WIRE:
      case COMMANDS.FIND_WIRE:
        setActiveButton("wire"); break;
      case COMMANDS.CREATE_NEW_BRANCH:
        setActiveButton("branch"); break;
      case COMMANDS.DRAW_SUPPLY_POINT:
        setActiveButton("supply"); break;
      case COMMANDS.DRAW_CABLE_SHAFT:
        setActiveButton("CableShaft"); break;
      case COMMANDS.DRAW_DOOR_OPENER:
        setActiveButton("DoorOpener"); break;
      default:
        setActiveButton(null);
    }
  }, [commandType]);

  const handleClick = (tool, command, message) => {
    const alreadyActive = tool === activeButton;
    if (alreadyActive) {
      dispatch(resetOperation());
      setActiveButton(null);
    } else {
      dispatch(setCommandType(command));
      dispatch(setCommandMessage(message));
      setActiveButton(tool);
    }
  };

  return (
    <div className={`toolInstallationAccordion ${isOpen ? "open" : "closed"}`}>
      {isOpen && (
        <div className="toolInstallation-left">
          <div className="toolInstallationRow">

            <button
              className={`toolInstallationButton ${activeButton === "supply" ? "active" : ""}`}
              style={{ width: buttonSize, height: buttonSize }}
              title="Şebeke Kutusu-Box"
              onClick={() => handleClick("supply", COMMANDS.DRAW_SUPPLY_POINT, "Besleme için İlk noktayı seçin")}
            >
              {getIcon("supplyBox", iconSize)}
            </button>

            <button
              className={`toolInstallationButton ${activeButton === "Socket" ? "active" : ""}`}
              style={{ width: buttonSize, height: buttonSize }}
              title="Priz"
              onClick={() => handleClick("Socket", COMMANDS.DRAW_SOCKET, "priz için İlk noktayı seçin")}
            >
              {getIcon("socket", iconSize)}
            </button>

            <button
              className={`toolInstallationButton ${activeButton === "Light" ? "active" : ""}`}
              style={{ width: buttonSize, height: buttonSize }}
              title="Anahtar"
              onClick={() => handleClick("Light", COMMANDS.DRAW_LIGHT, "İlk noktayı seçin")}
            >
              {getIcon("switchIcon", iconSize)}
            </button>

            <button
              className={`toolInstallationButton ${activeButton === "LightFixture" ? "active" : ""}`}
              style={{ width: buttonSize, height: buttonSize }}
              title="Armatür"
              onClick={() => handleClick("LightFixture", COMMANDS.DRAW_FIXTURE, "İlk noktayı seçin")}
            >
              {getIcon("fixture", iconSize)}
            </button>

            <button
              className={`toolInstallationButton ${activeButton === "BellButton" ? "active" : ""}`}
              style={{ width: buttonSize, height: buttonSize }}
              title="Zil Buton"
              onClick={() => handleClick("BellButton", COMMANDS.DRAW_BELL_BUTTON, "İlk noktayı seçin")}
            >
              {getIcon("bellButton", iconSize)}
            </button>

            <button
              className={`toolInstallationButton ${activeButton === "DoorOpener" ? "active" : ""}`}
              style={{ width: buttonSize, height: buttonSize }}
              title="Kapı Otomatiği (interkom hattına)"
              onClick={() => handleClick("DoorOpener", COMMANDS.DRAW_DOOR_OPENER, "İnterkom hattı üzerinde nokta seçin")}
            >
              <span style={{ fontSize: '10px', fontWeight: 'bold' }}>K.O.</span>
            </button>

            <button
              className={`toolInstallationButton ${activeButton === "CableShaft" ? "active" : ""}`}
              style={{ width: buttonSize, height: buttonSize }}
              title="Kablo Bacası"
              onClick={() => handleClick("CableShaft", COMMANDS.DRAW_CABLE_SHAFT, "Kablo bacası için ilk köşeyi seçin")}
            >
              {getIcon("cableShaft", iconSize)}
            </button>

          </div>

          {/* Panel aç/kapat butonları — AKTİF paftada kullanılabilir olanlar */}
          <div className="toolInstallationRow toolInstallationPanelRow">
            {visiblePanelToggles.map((p) => (
              <button
                key={p.key}
                className={`toolInstallationButton toolInstallationPanelToggle ${panelVis[p.key] ? "active" : ""}`}
                style={{ width: buttonSize, height: buttonSize }}
                title={`${p.title} — aç/kapat`}
                onClick={() => dispatch(togglePanel({ tabId: activeTabId, panel: p.key }))}
              >
                {getIcon(p.icon, iconSize)}
              </button>
            ))}
            <button
              className="toolInstallationButton"
              style={{ width: buttonSize, height: buttonSize }}
              title="Enerji Odası — düzenleyiciyi aç"
              onClick={() => energyRoomPayload && dispatch(openEnergyRoom(energyRoomPayload))}
            >
              {getIcon("energyRoom", iconSize)}
            </button>
          </div>
        </div>
      )}
      <div className="toolInstallation-toggle">
        <button className="toolButton toggleArrowButton" onClick={() => setIsOpen(prev => !prev)}>
          {isOpen ? "◀" : "Tesisat▶"}
        </button>
      </div>
    </div>
  );
};

export default ToolInstallation;
